import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import TableData from '../../components/TableData';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import { dateWithHours, parseISO } from '../../utils/dateFormatter';

export default function Falhas() {
  const history = useHistory();
  const classes = useStyles();
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const layoutDispatch = useLayoutDispatch();

  useEffect(() => {
    jobsRequest();
  }, [page]);

  async function jobsRequest() {
    toggleLoading(layoutDispatch);
    setError(null);
    try {
      const { data } = await api.get(`/job?pagina=${page}`);
      setTotal(data.totalPaginas);
      setJobs(data.dados.map((item) => ({
        ...item,
        criado_em: item.atualizado_em
          ? dateWithHours(parseISO(item.atualizado_em))
          : dateWithHours(parseISO(item.criado_em))
      })));

      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  async function handleRetry(index) {
    const find = jobs[index];
    toggleLoading(layoutDispatch);
    try {
      await api.post(`/job/${find.id_job_falha}`);
      Notification({
        type: 'shipped',
        message: 'Processo enviado novamente',
        variant: 'contained',
        color: 'success',
      });
      jobsRequest();
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    toggleLoading(layoutDispatch);
  }

  function handleReload() {
    jobsRequest();
  }

  return (
    <>
      <PageTitle
        title="Processos com falha"
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar os processos com falha
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Processos com falha"
              columns={[{
                name: 'nome_job',
                label: 'Nome do processo',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'erro',
                label: 'Mensagem de erro',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'criado_em',
                label: 'Data e hora',
                options: {
                  filter: true,
                  sort: false,
                }
              }]}
              data={jobs}
              page={page}
              total={total}
              onSetPage={handlePage}
              showRetry
              onRetry={handleRetry}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
